import React, { ReactElement } from 'react'

import { NextPage } from 'app/types/decalarations/next'

import MainLayout from '~/components/layouts/MainLayout'
import AuthTrianglesContainer from '~/components/layouts/TrianglesContainer'
import SignUpBusinessView from '~/views/Auth/SignUpBusinessView'

const BusinessAccountSignUpPage: NextPage = () => <SignUpBusinessView />

BusinessAccountSignUpPage.getLayout = (page: ReactElement) => (
  <MainLayout>
    <AuthTrianglesContainer>{page}</AuthTrianglesContainer>
  </MainLayout>
)

BusinessAccountSignUpPage.getMeta = (intl) => ({
  title: intl.formatMessage({
    defaultMessage: 'Business Account Sign Up'
  }),
  description: intl.formatMessage({
    defaultMessage: 'Business Account Sign Up description'
  })
})

export default BusinessAccountSignUpPage
